/**
 * Define all of your application routes here
 * for more information on routes,
 * official documentation https://router.vuejs.org/en/
 */
import UserProfile from '@/views/UserProfile.vue'
import LoginHome from '@/views/LoginHome.vue'
import LoginForm from '@/views/LoginForm.vue'
import ForgotPasswordForm from '@/views/ForgotPasswordForm.vue'
import User from '@/views/User.vue'
import Sandbox from '@/views/Sandbox.vue'
import Userweb from '@/views/UserWeb.vue'
import Menu from '@/views/Menu.vue'
import Role from '@/views/Role.vue'
import ChangePassword from '@/views/usersetting/ChangePassword.vue'
import UserRole from '@/views/UserRole'
import RoleMenu from '@/views/RoleMenu'
import Home from '@/views/Home.vue'
import Page404 from '@/views/404.vue'
import Page403 from '@/views/403.vue'
import ProfilPengguna from '@/views/ProfilPengguna.vue'
import DashboardView from '@/views/DashboardView.vue'
import OrganisasiList from '@/views/organisasi/OrganisasiList.vue'
import OrganisasiAddUpdate from '@/views/organisasi/OrganisasiAddUpdate'
import ChangePasswordWithToken from '@/views/usersetting/ChangePasswordWithToken.vue'
import { frontendUrl, ssoUrl, clientId } from '../config/env'

export default [
  {
    path: '/',
    component: LoginHome,
    children: [
      { path: '', redirect: '/home-page' },
      {
        path: '/cas',
        beforeEnter (to, from, next) {
          const redirectUri = `${frontendUrl}/oauth/code`
          const scope = 'profile'

          window.location = `${ssoUrl}/cas/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`
        },
      },
      {
        path: '/home-page',
        name: 'HOME',
        component: LoginForm,
        meta: { loginForm: true },
      },
      {
        path: '/logout',
        name: 'HOME',
        component: LoginForm,
        meta: { loginForm: true },
      },
      {
        path: '/oauth/code',
        name: 'LOGIN_HOME',
        component: LoginForm,
        props: route => ({ code: route.query.code }),
        meta: { loginForm: true },
      },
      {
        path: '/forgot-password',
        name: 'FORGOT_PASSWORD',
        component: ForgotPasswordForm,
        meta: { ForgotPasswordForm: true },
      },
      {
        path: '/404',
        name: '404',
        component: Page404,
        meta: { Page404: true },
      },
      {
        path: '/403',
        name: '403',
        component: Page403,
        meta: { Page403: true },
      },
      {
        path: '/change-password/token/:token',
        name: 'CHANGE_PASSWORD_WITH_TOKEN',
        component: ChangePasswordWithToken,
        meta: { ChangePasswordWithToken: true },
      },
    ],
  },
  {
    path: '/dashboard-view',
    component: DashboardView,
    children: [
      {
        path: '/home',
        name: 'HOME',
        component: Home,
        meta: { requiresAuth: true },
      },
      {
        path: '/user-profile',
        name: 'USER_PROFILE',
        component: UserProfile,
        meta: { requiresAuth: true },
      },
      {
        path: '/user',
        name: 'USER',
        component: User,
        meta: { requiresAuth: true },
      },
      {
        path: '/sandbox',
        name: 'SANDBOX',
        component: Sandbox,
        meta: { requiresAuth: true },
      },
      {
        path: '/userweb',
        name: 'USERWEB',
        component: Userweb,
        meta: { requiresAuth: true, kode: 'USER' },
      },
      {
        path: '/menu',
        name: 'MENU',
        component: Menu,
        meta: { requiresAuth: true },
      },
      {
        path: '/role',
        name: 'ROLE',
        component: Role,
        meta: { requiresAuth: true },
      },
      {
        path: '/user-role',
        name: 'USER_ROLE',
        component: UserRole,
        meta: { requiresAuth: true },
      },
      {
        path: '/role-menu',
        name: 'ROLE_MENU',
        component: RoleMenu,
        meta: { requiresAuth: true },
      },
      {
        path: '/change-password',
        name: 'CHANGE_PASSWORD',
        component: ChangePassword,
        meta: { requiresAuth: true },
      },
      {
        path: '/profil-pengguna',
        name: 'PROFIL_PENGGUNA',
        component: ProfilPengguna,
        meta: { requiresAuth: true },
      },
      {
        path: '/organisasi',
        name: 'ORGANISASI',
        component: OrganisasiList,
        meta: { requiresAuth: true },
      },
      {
        path: '/organisasi/:id',
        name: 'ORGANISASI_ADD_UPDATE',
        component: OrganisasiAddUpdate,
        meta: { requiresAuth: true },
      },
    ],
  },
]
